import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { DocumentModule } from './document/document.module';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ChangeRequestModule } from './change-request/change-request.module';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { EqmsScopeModule } from './eqms-scope/eqms-scope.module';
import { HeaderProcessingInterceptor } from './shared/interceptor/header-processing.interceptor';
import { SpinnerInterceptor } from './shared/interceptor/spinner.interceptor';
import { DocumentTemplateManagementModule } from './document-template-management/document-template-management.module';
import { DelegateModule } from './delegate/delegate.module';
import { UserSelectComponent } from './user-select/user-select.component';
import { DelegateSliderModule } from './delegate-slider/delegate-slider.module';
import { ChangeControlCatalogueModule } from './change-control-catalogue/change-control-catalogue.module';
import { ChangeControlModule } from './change-control/change-control.module';
 import { setLicenseKey } from 'survey-core';
import { environment } from '../environments/environment';
import { ReportingModule } from './reporting/reporting.module';
import { RetryInterceptor } from './shared/interceptor/retry.interceptor';
import { ActionItemCatalogueModule } from './action-item-catalogue/action-item-catalogue.module';
import { TitleCasePipe } from '@angular/common';
import { SpinnerComponent } from './shared-components/spinner/spinner.component';
import { CoreModule } from './core/core.module';

 setLicenseKey(
   environment.surveyJsProductKey
 );
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HeaderProcessingInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RetryInterceptor,
    multi: true,
  }
];

@NgModule({
  declarations: [
    AppComponent,
    UserSelectComponent
    
  ],
  imports: [
    BrowserModule,
    NoopAnimationsModule,
    CoreModule,
    AppRoutingModule,
    DocumentModule,
    ChangeRequestModule,
    HttpClientModule,
    FormsModule,
    SharedModule,
    EqmsScopeModule,
    DelegateModule,
    DocumentTemplateManagementModule,
    DelegateSliderModule,
    ChangeControlCatalogueModule,
    ChangeControlModule,
    ReportingModule,
    ActionItemCatalogueModule,
    SpinnerComponent
  ],
  providers: [httpInterceptorProviders, TitleCasePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
